import { Action, Store } from '@reduxjs/toolkit';

import { initializeDataConnections } from './initializeDataConnections';
import { initializeLoginTools } from './initializeLoginTools';
import { LoginDataSliceState } from './store/logInDataSlice';

export function initializeDataConnectionsAndLoginTools(store: Store<LoginDataSliceState, Action>) {
  initializeDataConnections(store);
  initializeLoginTools(store);
}
